<template>
  <div class="main">
    <div class="person">
      <h2>登录</h2>
      <div>
        <Icon type="person" class="login_icon"></Icon>
        <Input v-model="userName" style="width: 300px" placeholder="用户名"/>
      </div>
      <div>
        <Icon type="android-lock" class="login_icon"></Icon>
        <Input v-model="password" type="password" style="width: 300px" placeholder="密码" @keyup.13.native="login"/>
      </div>
      <div>
        <i class="iconfont icon-verificationcode login_icon" style="font-size: 16px;margin: 0 2px 0 -4px;"></i>
        <Input v-model="identityCode" style="width: 150px" placeholder="验证码" @keyup.13.native="login" :maxlength=4 />
        <img :src="codeImg" alt="验证码" style="display: inline-block; width: 120px; margin-left: 20px; height: 32px;vertical-align: middle;" @click="getIdentityCode()" />
      </div>
      <div>
        <Button type="primary" @click="login" class="submit">登录</Button>
      </div>
    </div>
    <div class="copyright">
      Copyright © 2017，Damai-IoT，All Rights Reserved | 浙ICP备18001529号
    </div>
  </div>
</template>

<script>
import {httpUrl} from '../../api'
import {errorHandler} from '../../util/errorHandler'
import {nError} from '../../util/notice'
import md5 from 'js-md5'
import {errorMessage} from '../../util/errorCode'
import layer from 'vue-layer-mobile'

export default {
  name: 'login',
  data () {
    return {
      userName: '',
      password: '',
      codeImg: '',
      identityCode: ''
    }
  },
  created () {
    this.getIdentityCode()
  },
  methods: {
    getIdentityCode () {
      this.$axios.post(`${httpUrl.url}/manage/getIdentityCode`, {})
        .then(res => {
          this.codeImg = res.data.data
        })
        .catch(errorHandler('获取验证码失败'))
    },
    login () {
      if (!this.userName) {
        nError('用户名不能为空')
        return false
      }
      if (!this.password) {
        nError('密码不能为空')
        return false
      }
      if (!this.identityCode) {
        nError('验证码不能为空')
        return false
      }
      let userName = this.userName.toLowerCase()
      let pw = this.password + userName
      let once = md5(pw) + userName
      let pwd
      for (let i = 0; i < 9; i++) {
        pwd = md5(once)
        once = pwd + userName
      }
      this.$axios.post(`${httpUrl.url}/manage/login`, {
        userName: this.userName,
        password: pwd,
        identityCode: this.identityCode
      })
        .then(res => {
          if (res.data.retCode === 1) {
            window.sessionStorage.setItem('theDevUserName', this.userName)
            window.sessionStorage.setItem('navListState', 'upgrade_management')
            let authData = res.data.data.join(',')
            window.sessionStorage.setItem('authStr', authData)
            this.$router.push({
              path: '/upgrade_management'
            })
          }
        })
        .catch(e => {
          let err = JSON.stringify(e)
          let res = JSON.parse(err).response
          if (+res.data.data > 0) {
            layer.toast({
              icon: 'icon-check',
              content: errorMessage(+res.data.data),
              time: 1000
            })
          } else {
            layer.toast({
              icon: 'icon-check',
              content: res.data.data,
              time: 1000
            })
          }

          this.$axios.post(`${httpUrl.url}/manage/getIdentityCode`, {})
            .then(res => {
              this.codeImg = res.data.data
            })
            .catch(errorHandler('获取验证码失败'))
        })
    }
  }
}
</script>

<style scoped>
  .main{
    width: 100%;
    height: 100%;
    background-color: #eee;
    position: relative;
    background-image: url('../../assets/bg.jpg');
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .person {
    width: 400px;
    background-color: white;
    position: absolute;
    top: 180px;
    left: 0;
    right: 0;
    margin: 0 auto;
  }
  .person div {
    margin: 10px 0;
    text-align: center;
  }
  .person h2{
    font-weight: 500;
    font-size: 32px;
    line-height: 32px;
    text-align: center;
    margin: 20px 0;
  }

  .login_icon {
    margin: 0 5px;
    color: #999;
    font-size: 18px;
    line-height: 32px;
  }

  .submit {
    width: 120px;
    margin: 20px;
  }

  .copyright {
    color: #eee;
    line-height: 50px;
    text-align: center;
    position: absolute;
    bottom: 10px;
    left: 0;
    right: 0;
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/views/login/login.vue